(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CostTypeDialogController', CostTypeDialogController);

    CostTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CostType'];

    function CostTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CostType) {
        var vm = this;
        vm.costType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:costTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.costType.id !== null) {
                CostType.update(vm.costType, onSaveSuccess, onSaveError);
            } else {
                CostType.save(vm.costType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
